import { _loadComponent } from '@/services/helper';

export default function(resolve: any) {
  _loadComponent('Header/', resolve);
}
